import React, { useState } from "react";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import {
  NuDate,
  NuInput,
  NuMobileNumber,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import { useFormik } from "formik";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import * as yup from "yup";
import FormikSelectTwo, {  FormikSelectWithAdd } from "../../../../Components/Utils/Select";
import { useToast } from "../../../../Components/Others/ToastServices";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import CustomImgUpload from "../../../../Components/Utils/CustomImgUpload";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { CountryMIN } from "../../../../assets/CountryMini";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import { MultiSelectSet } from "../../../../Components/Utils/MultiSelect";
import useFetchMetaStar from "../../../../Components/Hooks/useFetchMetaStar";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseAddData from "../../../../Components/Hooks/useAddData";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";

const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "PDF",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];



function CreateTeam() {
  const { value: Inspection_Team, getData: refInspection_Team } = useFetchMataData(`/dropdown/dropdown-details/`, "Inspection_Team");
  const { value: Designation_Team, getData: refDesignation_Team } = useFetchMataData(`/dropdown/dropdown-details/`, "Designation_Team");
  const { data: user } = UseDropDown(`/user/new-drop-down`);
  const { Oncancel, addFormData, contextHolder, isLoading } = useAddFormData();

  const [createNew, setCreateNew] = useState({
    email: "",
    designation: "",
    division: "",
    dob: "",
    dateOfJoin: "",
    countryCode: "",
    phone: "",
    dateOfRelieved: "",
    gender: "",
    status: "",
    qualifications: [],
    skills: [],
    name: ""
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({}),
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(value));
      formData.append("teamImage", image.raw);
      await addFormData({ url: `/team/add`, formData: formData, navigateUrl: `/teammember/team`, resetForm: resetForm });
    },
  });

  const [inputKey, setInputKey] = useState(Date.now());
  const [image, setImage] = useState([]);
  const [skillInput, setSkillInput] = useState("");
  const [qualificationInput, setQualificationInput] = useState("");

  const handleChangeImg = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };

  const handleImageRemove = () => {
    setImage({ preview: "", raw: "" });
    setInputKey(Date.now());
  };

  const addSkill = () => {
    if (skillInput.trim()) {
      const newSkills = [...formik.values.skills, skillInput.trim()];
      formik.setFieldValue("skills", newSkills);
      setSkillInput("");
    }
  };

  const removeSkill = (index) => {
    const newSkills = formik.values.skills.filter((_, i) => i !== index);
    formik.setFieldValue("skills", newSkills);
  };

  const addQualification = () => {
    if (qualificationInput.trim()) {
      const newQualifications = [...formik.values.qualifications, qualificationInput.trim()];
      formik.setFieldValue("qualifications", newQualifications);
      setQualificationInput("");
    }
  };

  const removeQualification = (index) => {
    const newQualifications = formik.values.qualifications.filter((_, i) => i !== index);
    formik.setFieldValue("qualifications", newQualifications);
  };

  return (
    <div className="w-full h-full py-2 px-4">
      {contextHolder}
      <div className="flex justify-between mb-4">
        <Breadcrumb
          items={[
            {
              name: "Team",
              link: "/teammember/team",
            },
            { name: "Create" },
          ]}
        />
        <BackButton />
      </div>

      <div className="w-full mx-auto h-[calc(100vh-151px)] overflow-y-auto">
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full mx-auto p-4 bg-white rounded-md">
            <div className="w-full h-full flex justify-start content-start flex-wrap mb-4">
              <div className="w-full">
                <SettingHeading title="Team" />
              </div>
              <CustomImgUpload
                key={inputKey}
                borderStyle="dashed"
                isRemove={true}
                width="w-full"
                removeFunction={handleImageRemove}
                handleChange={handleChangeImg}
                preview={image.preview || createNew.image || ""}
              />
              <NuInput
                label="Name"
                type="text"
                formik={formik}
                placeholder="Enter Name"
                name="name"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="email"
                label="Email"
                placeholder="Email"
                formik={formik}
                name="email"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuMobileNumber
                nunCode="countryCode"
                label="Mobile"
                placeholder="Mobile"
                formik={formik}
                name="phone"
                width="w-full md:w-1/2 lg:w-1/3"
                FixPosition={true}
                PortalTarget={false}
              />
              <NuDate
                label="Date of Birth"
                placeholder="Date of Birth"
                formik={formik}
                name="dob"
                width="w-full md:w-1/3 "
              />
              <DropDownAddMetaData
                label="Designation"
                placeholder="Choose"
                Options={Designation_Team}
                formik={formik}
                name="designation"
                width="w-full md:w-1/3 md:-mt-1"
                getFunc={refDesignation_Team}
                displayProperty={"Designation"}
                propertyName={"Designation_Team"}
                FixPosition={false}
                PortalTarget={false}
              />
              <FormikSelectTwo
                type="text"
                label="Gender"
                placeholder="Gender"
                Options={[
                  { value: "Male", label: "Male" },
                  { value: "Female", label: "Female" },
                  { value: "Others", label: "Others" },
                ]}
                formik={formik}
                name="gender"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <DropDownAddMetaData
                label="Division"
                placeholder="Choose"
                Options={Inspection_Team}
                formik={formik}
                name="division"
                width="w-full md:w-1/3 md:-mt-1"
                getFunc={refInspection_Team}
                displayProperty={"Division"}
                propertyName={"Inspection_Team"}
                FixPosition={false}
                PortalTarget={false}
              />
              <NuDate
                label="Date of Join"
                placeholder="Date of Join"
                formik={formik}
                name="dateOfJoin"
                width="w-full md:w-1/3 "
              />
              <NuDate
                label="Date Relieved"
                placeholder="Date Relieved"
                formik={formik}
                name="dateOfRelieved"
                width="w-full md:w-1/3 "
              />
              <div className="w-full sm:flex gap-4">
                <div className="sm:w-[50%] mx-auto p-1.5 bg-white rounded-md mt-4">
                  <div className="w-full h-full flex justify-start content-start flex-wrap">
                    <div className="w-full px-2">
                      <SettingHeading title="Skill" />
                      <div className="flex items-center space-x-2 mb-3">
                        <NuInput
                          type="text"
                          placeholder="Enter Skill"
                          value={skillInput}
                          onChange={(e) => setSkillInput(e.target.value)}
                          width="w-full"
                        />
                        <button
                          type="button"
                          onClick={addSkill}
                          className="bg-baseColor-primary text-white px-2 py-1 rounded-md shadow hover:bg-blue-600 transition"
                        >
                          +
                        </button>
                      </div>
                      <div className="border rounded-lg p-3 space-y-2 w-full bg-white h-48 overflow-y-auto">
                        {formik.values.skills.length === 0 && (
                          <p className="text-sm text-gray-400 italic">No skills added.</p>
                        )}
                        {formik.values.skills.map((skill, index) => (
                          <div
                            key={index}
                            className="flex items-center justify-between border rounded-md px-2 py-1 "
                          >
                            <span className="text-gray-800 text-xs">{skill}</span>
                            <button
                              type="button"
                              onClick={() => removeSkill(index)}
                              className="text-red-500 hover:text-red-700 text-lg font-semibold"
                            >
                              ×
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sm:w-[50%] mx-auto p-1.5 bg-white rounded-md mt-4">
                  <div className="w-full h-full flex justify-start content-start flex-wrap">
                    <div className="w-full px-2">
                      <SettingHeading title="Qualification" />
                      <div className="flex items-center space-x-2 mb-3">
                        <NuInput
                          type="text"
                          placeholder="Enter Qualification"
                          value={qualificationInput}
                          onChange={(e) => setQualificationInput(e.target.value)}
                          width="w-full"
                        />
                        <button
                          type="button"
                          onClick={addQualification}
                          className="bg-baseColor-primary text-white px-2 py-1 rounded-md shadow hover:bg-blue-600 transition"
                        >
                          +
                        </button>
                      </div>
                      <div className="border rounded-lg p-3 space-y-2 w-full bg-white h-48 overflow-y-auto">
                        {formik.values.qualifications.length === 0 && (
                          <p className="text-sm text-gray-400 italic">No qualifications added.</p>
                        )}
                        {formik.values.qualifications.map((qualification, index) => (
                          <div
                            key={index}
                            className="flex items-center justify-between border rounded-md px-2 py-1 "
                          >
                            <span className="text-gray-800 text-xs">{qualification}</span>
                            <button
                              type="button"
                              onClick={() => removeQualification(index)}
                              className="text-red-500 hover:text-red-700 text-lg font-semibold"
                            >
                              ×
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full mx-auto my-4 mt-8 pb-2">
                <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel(-1);
                    }}
                  />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateTeam;